import React, { useEffect, useState } from "react";
import Select, { TOption, TOptionType } from "../../../Components/Select";
import { getDeviceOptions, getTopicOptions } from "../utils";
import { IDevice } from "../../devices/types";
import { TMqttTrigger } from "./types";
import { useTranslation } from "react-i18next";

interface IMqttTriggerFormProps {
  trigger: TMqttTrigger;
  devices: IDevice[];
  onChange: (mqttTrigger: TMqttTrigger) => void;
}

const MqttTriggerForm = (props: IMqttTriggerFormProps) => {
  const { trigger, devices, onChange } = props;
  const device_id = trigger.device_id || devices[0].id;

  const [topicOptions, setTopicOptions] = useState<TOption<TOptionType>[]>(
    getTopicOptions(devices, device_id)
  );

  const [mqttTrigger, setMqttTrigger] = useState<TMqttTrigger>({
    device_id: device_id,
    topic: topicOptions[0].value as string,
    ...trigger,
  });

  useEffect(() => {
    onChange(mqttTrigger);
    // eslint-disable-next-line
  }, [mqttTrigger]);
  const { t } = useTranslation();

  const updateMqttTrigger = (newMqttTrigger: TMqttTrigger) => {
    setMqttTrigger(newMqttTrigger);
  };

  return (
    <>
      <Select
        fullWidth
        label={t("Device")}
        options={getDeviceOptions(devices)}
        value={mqttTrigger.device_id}
        onChange={(event) => {
          const newDeviceId = parseInt(event.target.value);
          const newTopicOptions = getTopicOptions(devices, newDeviceId);
          setTopicOptions(newTopicOptions);
          updateMqttTrigger({
            ...mqttTrigger,
            device_id: newDeviceId,
            topic: newTopicOptions[0].value as string,
          });
        }}
        margin="none"
        data-cy="mqtt-trigger-select-device"
      />
      <Select
        fullWidth
        label={t("Topic")}
        options={topicOptions}
        value={mqttTrigger.topic}
        onChange={(event) =>
          updateMqttTrigger({ ...mqttTrigger, topic: event.target.value })
        }
        margin="none"
        data-cy="mqtt-trigger-select-topic"
      />
    </>
  );
};

export default MqttTriggerForm;
